import i18n, { type InitOptions } from 'i18next';
import LanguageDetector, {
  type DetectorOptions,
} from 'i18next-browser-languagedetector';
import HttpBackend, { type HttpBackendOptions } from 'i18next-http-backend';
import yaml from 'js-yaml';
import { initReactI18next } from 'react-i18next';

import { dpConfig } from 'src/config';
import { Language } from 'src/enums/Language';
import { PreferencesParam } from 'src/enums/PreferencesParam';

type I18nInitOptions = InitOptions<HttpBackendOptions & DetectorOptions> & {
  enableSelector: true;
};

const i18nOptions: I18nInitOptions = {
  ns: [
    'common',
    'configuration',
    'errors',
    'forecast',
    'history',
    'navigation',
    'novelties',
    'preferences',
  ],
  react: { useSuspense: true },
  defaultNS: 'common',
  cleanCode: true,
  enableSelector: true,
  fallbackLng: dpConfig.language.fallback,
  load: 'languageOnly',
  supportedLngs: Object.values(Language),
  detection: {
    order: ['localStorage', 'navigator'],
    convertDetectedLanguage: (lng) => lng.slice(0, 2),
    lookupLocalStorage: PreferencesParam.LANGUAGE,
  },
  backend: {
    loadPath: '/locales/{{lng}}/{{ns}}.yaml',
    parse: (data: string): { [key: string]: unknown } =>
      yaml.load(data) as { [key: string]: unknown },
  },
};

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init<HttpBackendOptions & DetectorOptions>(i18nOptions);

export default i18n;
